export enum ServiceActivityClosedLabel {
    ongoing = 'ongoing',
    sent = 'sent',
    supervised = 'supervised',
    withPatient = 'withPatient',
}
